import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HomeData } from '../../providers/home-data';
// import _ from 'lodash';

@Injectable()
// Share methods between Mobile and Full Web view
export class HomeCommon {
	constructor(
		private homeData: HomeData
	) {}

	public commonMethod(){
		console.log("Hello Home");
	}

	public getHomeWidgets(){
		var self = this;
        return Observable.create((observer) =>{
			self.homeData.getHomePageWidgets().subscribe((widgets) => {
				observer.next(widgets);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/home/pages/home/home.common.ts